module.exports = __webpack_public_path__ + "img/noorderzorg.392c9b13.png";